// Используем флаг, чтобы hook регистрировался только один раз
let hookRegistered = false
let scrollTimeout: ReturnType<typeof setTimeout> | null = null

export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.client && !hookRegistered) {
        hookRegistered = true
        const nuxtApp = useNuxtApp()

        nuxtApp.hook("page:finish", () => {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout)
                scrollTimeout = null
            }

            if (history.state.scroll) {
                scrollTimeout = setTimeout(() => {
                    window.scrollTo(history.state.scroll)
                    scrollTimeout = null
                }, 0);
            } else {
                scrollTimeout = setTimeout(() => {
                    window.scrollTo(0, 0)
                    scrollTimeout = null
                }, 0);
            }
        });
    }
})
